export default __webpack_public_path__ + "82ea80e063dba51cf97b2175a2e5d611.svg";